<template>
  <div class="dialogs">
    <div class="title_txt">
      <span>{{titls}}</span>
      <img src="@/assets/xxx.png" alt="" @click="close" />
    </div>
    <div class="boxs">
      <div class="center">
        <div class="pro_tabs">
          <div
            v-for="item in tabs"
            :key="item.index"
            :class="tabsindex == item.index ? 'pro_active' : ''"
          >
            {{ item.title }}
          </div>
        </div>
        <div class="centers_boxs">
          <el-form
            :label-position="labelPosition"
            :model="ruleForm"
            ref="ruleForms"
            label-width="115px"
            :rules="rules"
            class="demo-ruleForm"
          >
            <div v-if="tabsindex == 1">
              <div class="flex_two">
                <el-form-item label="产品名称:"  prop="product_name">
                  <el-input
                    :disabled="disableds"
                    maxlength="20"
                    v-model="ruleForm.product_name"
                    placeholder="请输入产品名称"
                  ></el-input>
                </el-form-item>
                <el-form-item label="产品分类:" prop="type_id">
                  <el-select
                    v-model="ruleForm.type_id"
                    :disabled="disableds"
                    placeholder="请选择产品分类"
                  >
                    <el-option
                      v-for="item in typeArr"
                      :key="item.id"
                      :label="item.type_name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </div>
              <el-form-item label="产品简述:">
                <el-input
                  v-model="ruleForm.product_memo"
                  placeholder="请输入产品简述"
                  :disabled="disableds"
                ></el-input>
              </el-form-item>
              <el-form-item label="产品详情:" prop="product_detail">
                <quill-editor
                  ref="myQuillEditor"
                  :disabled="disableds"
                  v-model="ruleForm.product_detail"
                >
                </quill-editor>
              </el-form-item>
              <el-form-item label="发票开具说明:">
                <quill-editor
                  ref="myQuillEditor"
                  v-model="ruleForm.invoice_notice"
                  :disabled="disableds"
                >
                </quill-editor>
              </el-form-item>
              <el-form-item label="产品封面:" prop="cover_img">
                <div class="feng">
                  <el-upload
                    :disabled="disableds"
                    class="avatar-uploader"
                    action="http://eventapi.softykt.com/api/event/uploadInfoRemit"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
                    :data="datas"
                  >
                    <img
                      v-if="ruleForm.cover_img"
                      :src="ruleForm.cover_img"
                      class="avatar"
                    />
                    <i v-else class="el-icon-plus avatar-uploader-icon"> </i>
                  </el-upload>
                  <span class="proFm_span"
                    >注：请上传1M一下的图片(此图片用于平台产品宣传，请认证对待)，
                    支持png、jpg、jpeg</span
                  >
                </div>
              </el-form-item>
              <el-form-item label="产品主图:">
                <el-upload
                  action="http://eventapi.softykt.com/api/event/uploadInfoRemit"
                  :limit="4"
                  :disabled="disableds"
                  :class="hideUpload ? 'hide' : 'width172'"
                  :on-success="attachUploadSuccess"
                  :data="datas"
                  list-type="picture-card"
                  ref="pictureUpload"
                  :file-list="transDetImgList"
                >
                  <i slot="default" class="el-icon-plus"></i>
                  <div slot="file" slot-scope="{ file }">
                    <img
                      class="el-upload-list__item-thumbnail"
                      :src="file.url"
                      alt
                    />
                    <span class="el-upload-list__item-actions">
                      <span
                        v-if="!disabled"
                        class="el-upload-list__item-delete"
                        @click="handleRemove(file)"
                      >
                        <i class="el-icon-delete"></i>
                      </span>
                    </span>
                  </div>
                </el-upload>
              </el-form-item>
            </div>
            <div v-if="tabsindex == 2">
              <el-form-item label="销售时间:" prop="sell_start">
                <div class="flex_two saletime">
                  <el-date-picker
                    type="datetime"
                    :disabled="disableds"
                    v-model="ruleForm.sell_start"
                    :picker-options="pickerOptions"
                    @change="changeData(true)"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    placeholder="销售开始日期"
                  >
                  </el-date-picker>
                  <span>至</span>
                  <el-date-picker
                    type="datetime"
                    :picker-options="pickerOptions"
                    :disabled="disableds"
                    @change="changeData(false)"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    v-model="ruleForm.sell_end"
                    placeholder="销售结束日期"
                  >
                  </el-date-picker>
                </div>
              </el-form-item>
            </div>
            <div v-if="tabsindex == 3">
              <div
                class="flex_two saletime boxs_content"
                v-for="(item, index) in group"
                :key="item.index"
              >
                <div class="flex">
                  <div>
                  <el-form-item label="组别名称:">
                    <el-input :disabled="disableds" v-model="item.group_name" placeholder="例：小学组">
                    </el-input>
                  </el-form-item>
                </div>
                <div>
                  <el-form-item label="组别价格:">
                    <el-input
                      :disabled="disableds"
                      @input="valueChange(item)"
                      v-model="item.price"
                      type="number"
                      placeholder="可设置到小数点后两位"
                    >
                      <template slot="append"> 元 </template>
                    </el-input>
                  </el-form-item>
                </div>
                </div>
                <div class="flex flw_twos">
                  <div>
                    <el-form-item label="库存总数量:">
                      <el-input :disabled="disableds" v-model="item.all_stock" placeholder="可设置到个位数">
                      </el-input>
                    </el-form-item>
                  </div>
                  <div>
                    <el-form-item label="每个ID限购数量:">
                      <el-input
                        :disabled="disableds"
                        v-model="item.limit_num"
                        type="number"
                        placeholder="默认0为不限制数量"
                      >
                      </el-input>
                    </el-form-item>
                  </div>
                </div>
                <img
                  class="close_group"
                  @click="closeGroup(index)"
                  src="@/assets/xhh.png"
                  alt=""
                  v-if="index > 0"
                />
              </div>
              <div class="add_option" @click="addGroup">添加组别</div>
              <el-form-item label="能否退款:" prop="refund_flag">
                <el-radio-group v-model="ruleForm.refund_flag" :disabled="disableds">
                  <el-radio :label="2">禁止退款</el-radio>
                  <el-radio :label="1">允许退款</el-radio>
                  <el-radio :label="3">仅退款</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
            <div v-if="tabsindex == 4">
              <el-form-item label="配送服务:">
                  <el-radio-group v-model="ruleForm.delivery_flag" :disabled="disableds">
                    <el-radio :label="1">包邮</el-radio>
                    <el-radio :label="2">不包邮</el-radio>
                    <el-radio :label="3">偏远地区不包邮</el-radio>
                  </el-radio-group>
              </el-form-item>
              <el-form-item label="非包邮地区:"  v-if="ruleForm.delivery_flag!=1">
              </el-form-item>
              <div class="baoyou" v-if="ruleForm.delivery_flag!=1">
                <div v-for="(item,index) in delivery" :key="index">
                  <el-form-item label="地区名称:">
                    <el-select v-model="item.not_free_city" placeholder="请选择" clearable>
                      <el-option
                        v-for="item in province"
                        :key="item.provinceName"
                        :label="item.provinceName"
                        :value="item.provinceName"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="配送价格:">
                    <el-input v-model="item.not_free_city_price" placeholder="可设置到小数点后两位">
                      <template slot="append">元</template>
                    </el-input>
                  </el-form-item>
                  <img
                    class="close_group"
                    @click="closeGroupss(index)"
                    src="@/assets/xhh.png"
                    alt=""
                    v-if="index > 0"
                  />
                </div>
              </div>
              <div class="addDiqu" @click="adddelivery" v-if="ruleForm.delivery_flag!=1">
                添加地区
              </div>
              <div class="flex_two">
                <el-form-item label="状态:">
                  <el-radio-group v-model="ruleForm.state" :disabled="disableds">
                    <el-radio :label="1">上线</el-radio>
                    <el-radio :label="2">停用</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </div>
          </el-form>
          <div class="form_btns">
            <div v-if="tabsindex > 1" @click="step">上一步</div>
            <div class="nexts" @click="next">{{ nxt }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import cityOptions from "@/assets/city.json";
import {
  getProductType , addProducts , productDetail
} from "@/request/scenic.js";
import { Message } from "element-ui";
export default {
  data() {
    return {
      pickerOptions: {
        disabledDate(v) {
          return v.getTime() < new Date().getTime() - 86400000;//  - 86400000是否包括当天
        }
      },
      disableds:false,
      hideUpload:'',
      nxt: "下一步",
      group: [
        {
          group_name:'',
          price:'',
          limit_num:'',
          all_stock:''
        },
      ],
      checkBox: "1",
      disabled: false,
      transDetImgList: [],
      radio: 1,
      typeArr: [],
      ruleForm: {
        token: window.sessionStorage.getItem("Token"),
        product_name:'',
        type_id:'',
        invoice_notice:'',
        product_memo:'',
        product_detail:'',
        cover_img:'',
        img1:'',
        img2:'',
        img3:'',
        img4:'',
        sell_start:'',
        sell_end:'',
        group_name:'',
        price:'',
        limit_num:'',
        all_stock:'',
        refund_flag:2,
        delivery_flag:1,
        state:1,
        not_free_city:'',
        not_free_city_price:'',
        id:''
      },
      datas: {
        token: window.sessionStorage.getItem("Token"),
        scenicid: window.sessionStorage.getItem("scenicid"),
      },
      rules: {
        signup_num:[
        { required: true, message: "请输入报名人数", trigger: "blur" },
        ],
        address: [
          { required: true, message: "请输入产品地址", trigger: "blur" },
        ],
        product_name: [
          { required: true, message: "请输入产品名称", trigger: "blur" },
        ],
        type_id: [{ required: true, message: "请选择分类", trigger: "change" }],
        statement_flag: [
          { required: true, message: "请选择", trigger: "change" },
        ],
        product_detail: [
          { required: true, message: "请输入产品详情", trigger: "blur" },
        ],
        cover_img: [
          { required: true, message: "请上传图片", trigger: "change" },
        ],
        sell_start: [
          { required: true, message: "请选择报名时间", trigger: "change" },
        ],
        use_start: [
          { required: true, message: "请选择核销时间", trigger: "change" },
        ],
        notice_flag: [
          { required: true, message: "请选择开赛提示", trigger: "change" },
        ],
        refund_flag: [
          { required: true, message: "请选择是否退款", trigger: "change" },
        ],
        limit_num: [
          { required: true, message: "请输入每个ID限购数量", trigger: "blur" },
        ],
        day_stock: [
          { required: true, message: "请输入每日库存", trigger: "blur" },
        ],
        all_stock: [
          { required: true, message: "请输入总库存", trigger: "blur" },
        ],
      },
      labelPosition: "right",
      tabsindex: "1",
      tabs: [
        {
          title: "产品详情",
          index: "1",
        },
        {
          title: "日期设置",
          index: "2",
        },
        {
          title: "价格设置",
          index: "3",
        },
        {
          title: "快递设置",
          index: "4",
        },
      ],
      fileList: [],
      options: [],
      titls:'',
      province:'',
      delivery:[
        {
          not_free_city:'',
          not_free_city_price:''
        }
      ]
    };
  },
  created() {
    this.province =  cityOptions
    getProductType(this.datas).then((res) => {
      if (res.data.rcode == 200) {
        this.typeArr = res.data.result
      }
    });
  },
  methods: {
    adddelivery(){
      this.delivery.push( {
          not_free_city:'',
          not_free_city_price:''
        })
    },
    valueChange(item) {
      item.price = item.price.replace(/(^\s*)|(\s*$)/g, "");
      const reg = /[^\d.]/g;
      // 只能是数字和小数点，不能是其他输入
      item.price = item.price.replace(reg, "");
      // 保证第一位只能是数字，不能是点
      item.price = item.price.replace(/^\./g, "");
      // 小数只能出现1位
      item.price = item.price
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".");
      // 小数点后面保留2位
      item.price = item.price.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3");
      if (item.price < 0) {
        item.price = "";
        return false;
      }
      item.price = e;
    },
    handleRemove(file) {
      if (this.transDetImgList.length != 0) {
        this.transDetImgList.map((item, index) => {
          if (item.url == file.url) {
            switch (index) {
              case 0:
                this.ruleForm.img1 = "";
                break;
              case 1:
                this.ruleForm.img2 = "";
                break;
              case 2:
                this.ruleForm.img3 = "";
                break;
              case 3:
                this.ruleForm.img4 = "";
                break;
              default:
                break;
            }
          }
        });
      }
      if (this.fileList.length != 0) {
        this.fileList.map((item, index) => {
          if (item.name == file.name) {
            switch (index) {
              case 0:
                this.ruleForm.img1 = "";
                break;
              case 1:
                this.ruleForm.img2 = "";
                break;
              case 2:
                this.ruleForm.img3 = "";
                break;
              case 3:
                this.ruleForm.img4 = "";
                break;
              default:
                break;
            }
          }
        });
      }
      if (this.transDetImgList.length < 4) {
        this.hideUpload = false;
      }
      this.$refs.pictureUpload.handleRemove(file);
    },
    step() {
      if (this.tabsindex == 2) {
        this.tabsindex = 1;
      }
      if (this.tabsindex == 3) {
        this.tabsindex = 2;
      }
      if (this.tabsindex == 4) {
        this.nxt = "下一步";
        this.tabsindex = 3;
      }
    },
    changeData1(flag) {
      if (flag) {
        if (this.ruleForm.use_end) {
          if (
            this.getDate(this.ruleForm.use_start) >=
            this.getDate(this.ruleForm.use_end)
          ) {
            this.ruleForm.use_start = "";
            this.$message.error("核销开始时间不能大于等于核销结束时间！");
          }
        }
        if (this.ruleForm.sell_end) {
          if (
            this.getDate(this.ruleForm.use_start) <=
            this.getDate(this.ruleForm.sell_end)
          ) {
            this.ruleForm.use_start = "";
            this.$message.error("核销开始时间不能小于等于报名结束时间！");
          }
        }
      } else {
        if (this.ruleForm.use_start) {
          console.log(123)
          if (
            this.getDate(this.ruleForm.use_end) <=
            this.getDate(this.ruleForm.use_start)
          ) {
            this.ruleForm.use_end = "";
            this.$message.error("核销结束时间不能小于核销开始时间！");
          }
        }
      }
    },
    changeData(flag) {
      if (flag) {
        if (this.ruleForm.sell_end) {
          if (
            this.getDate(this.ruleForm.sell_start) >=
            this.getDate(this.ruleForm.sell_end)
          ) {
            this.ruleForm.sell_start = "";
            this.$message.error("开始时间不能大于等于结束时间！");
          }
        }
      } else {
        if (this.ruleForm.sell_start) {
          if (
            this.getDate(this.ruleForm.sell_end) <=
            this.getDate(this.ruleForm.sell_start)
          ) {
            this.ruleForm.sell_end = "";
            this.$message.error("结束时间不能小于开始时间！");
          }
        }
        if (this.ruleForm.use_start) {
          if (this.getDate(this.ruleForm.use_start) <= this.getDate(this.ruleForm.sell_end)) {
            this.ruleForm.sell_end = "";
            this.$message.error("报名结束时间不能大于等于核销开始时间！");
          }
        }
      }
    },
    getDate(m) {
      var date = new Date(m);
      var time1 = date.getTime();
      return time1;
    },

    next() {
      if (this.tabsindex == 1) {
        if (this.ruleForm.product_name == "") {
          Message.error("请输入产品名称");
          return false;
        }
        if (this.ruleForm.type_id == "") {
          Message.error("请选择产品分类");
          return false;
        }
        if (this.ruleForm.product_detail == "") {
          Message.error("请输入详情");
          return false;
        }
        if (this.ruleForm.cover_img == "") {
          Message.error("请上传封面图");
          return false;
        }
        this.tabsindex = 2;
        return false;
      }
      if (this.tabsindex == 2) {
        if (!this.ruleForm.sell_start) {
          Message.error("请选择销售开始时间");
          return false;
        }
        if (!this.ruleForm.sell_end) {
          Message.error("请选择销售结束时间");
          return false;
        }
        this.tabsindex = 3;
        return false;
      }
      if (this.tabsindex == 3) {
        if (this.group[0].group_name == "") {
          this.$message.error("请输入组别名称");
          return false;
        }
        if (this.group[0].price == "") {
          this.$message.error("请输入价格");
          return false;
        }
        if (this.group[0].limit_num == "") {
          this.$message.error("请输入每人限购数量");
          return false;
        }
        if (this.group[0].all_stock == "") {
          this.$message.error("请输入总库存");
          return false;
        }
        if (this.group.length > 1) {
          //  this.group.length
          const uniqueSampleTypeIds = new Set(this.group.map(item => item.group_name));
          const hasDuplicateSampleTypeId = this.group.length !== uniqueSampleTypeIds.size;
          if(hasDuplicateSampleTypeId){
            this.$message.error('组别名称不能一致')
            return false
          }else{
          }
        }
        this.tabsindex = 4;
        this.nxt = "保存";
        return false;
      }
      if (this.tabsindex == 4) {

        let not_free_city = "";
        let not_free_city_price = "";
        this.delivery.map((item) => {
          not_free_city += item.not_free_city + ",";
          not_free_city_price += item.not_free_city_price + ",";
        });
        not_free_city_price = not_free_city_price.substring(0, not_free_city_price.length - 1);
        not_free_city = not_free_city.substring(0, not_free_city.length - 1);
        let group_name = "";
        let price = "";
        let limit_num = "";
        let all_stock = "";
        this.group.map((item) => {
          group_name += item.group_name + ",";
          price += item.price + ",";
          limit_num += item.limit_num + ",";
          all_stock += item.all_stock + ",";
        });
        group_name = group_name.substring(0, group_name.length - 1);
        price = price.substring(0, price.length - 1);
        limit_num = limit_num.substring(0, limit_num.length - 1);
        all_stock = all_stock.substring(0, all_stock.length - 1);
        this.ruleForm.group_name = group_name;
        this.ruleForm.price = price;
        this.ruleForm.limit_num = limit_num;
        this.ruleForm.all_stock = all_stock;
        this.ruleForm.not_free_city = not_free_city;
        this.ruleForm.not_free_city_price = not_free_city_price;
        addProducts(this.ruleForm).then((res) => {
          if (res.data.rcode == 200) {
            if(this.ruleForm.id){
              this.$message.success("修改成功");
            }else{
              this.$message.success("添加成功");
            }
            this.$emit("sucClick");
          } else {
            this.$message.error(res.data.msg);
          }
        });
      }
    },
    closeGroupss(index){
      this.delivery.splice(index,1)
    },
    closeGroup(index) {
      this.group.splice(index, 1);
    },
    // 添加类别
    addGroup() {
      this.group.push({
        group_name:'',
        price:'',
        limit_num:'',
        all_stock:''
      });
    },
    close() {
      this.$emit("proClose");
    },
    seeInfo(row) {
      if (row.id) {
        this.titls = '编辑产品'
        let data = {
          token: window.sessionStorage.getItem("Token"),
          id: row.id,
        };
        productDetail(data).then((res) => {
          if (res.data.rcode == 200) {
            this.ruleForm = res.data.result;
            this.ruleForm.token =  window.sessionStorage.getItem("Token")
            this.ruleForm.id = row.id;
            let img = [];
            if (this.ruleForm.img1) {
              img.push({
                url: this.ruleForm.img1,
              });
            }
            if (this.ruleForm.img2) {
              img.push({
                url: this.ruleForm.img2,
              });
            }
            if (this.ruleForm.img3) {
              img.push({
                url: this.ruleForm.img3,
              });
            }
            if (this.ruleForm.img4) {
              img.push({
                url: this.ruleForm.img4,
              });
            }
            this.transDetImgList = img;
            let group_name = this.ruleForm.group_name.split(",");
            let price = this.ruleForm.price.split(",");
            let limit_num = this.ruleForm.limit_num.split(",");
            let all_stock = this.ruleForm.all_stock.split(",");
            let size = group_name.length;
            this.group = [];
            for (let i = 0; i < size; i++) {
              let a = {};
              a.group_name = group_name[i];
              a.price = price[i];
              a.limit_num = limit_num[i]
              a.all_stock = all_stock[i]
              this.group.push(a);
            }

            let not_free_city = this.ruleForm.not_free_city.split(",");
            let not_free_city_price = this.ruleForm.not_free_city_price.split(",");
            let sizes = not_free_city.length;
            this.delivery = [];
            for (let i = 0; i < sizes; i++) {
              let a = {};
              a.not_free_city = not_free_city[i];
              a.not_free_city_price = not_free_city_price[i];
              this.delivery.push(a);
            }
          }
        });
      } else {
        this.titls = '添加产品'
      }
    },
    attachUploadSuccess(response, file, fileList) {
      this.fileList = fileList;
      switch (fileList.length) {
        case 1:
          this.ruleForm.img1 = response.result;
          break;
        case 2:
          this.ruleForm.img2 = response.result;
          break;
        case 3:
          this.ruleForm.img3 = response.result;
          break;
        case 4:
          this.ruleForm.img4 = response.result;
          break;
        default:
          break;
      }
      if (this.fileList.length == 4) {
        this.hideUpload = true;
      }
    },
    // 封面主图
    handleAvatarSuccess(res, file) {
      this.ruleForm.cover_img = res.result;
    },
  },
};
</script>
<style lang="less" scoped>
.baoyou{
  border: 1px solid #E5E5EA;
  padding: 2rem 2rem 2rem 0;
  box-sizing: border-box;
  >div{
    display: flex;
    justify-content: space-between;
  }
}
.addDiqu{
  width: 14rem;
  height: 4rem;
  border: 1px solid #246DEB;
  margin-top: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #246DEB;
  font-size: 1.6rem;
  cursor: pointer;
  border-radius: 0.8rem;
}
.total_boxs {
  display: flex;
  flex-direction: column;
  .total_select {
    display: flex;
    align-items: center;
    > div {
      margin-right: 2rem;
      display: flex;
      align-items: center;
      > div {
        width: 1.6rem;
        height: 1.6rem;
        border: 1px solid #d9d9d9;
        border-radius: 0.2rem;
        display: flex;
        align-items: center;
        justify-content: center;
        > div {
          width: 0.8rem;
          height: 0.8rem;
          background: #246deb;
        }
      }
      .active_totla {
        border-color: #246deb;
      }
      span {
        color: #000000;
        font-size: 1.4rem;
        margin-left: 1.4rem;
        display: block;
      }
    }
  }
  .times_totla {
    display: flex;
    align-items: center;
    margin-top: 2rem;
    > span {
      color: #666666;
      font-size: 1.4rem;
      white-space: nowrap;
      &:nth-child(1) {
        margin-right: 2rem;
      }
      &:nth-child(3) {
        margin-left: 2rem;
      }
    }
  }
}
::-webkit-scrollbar {
  /* 对应纵向滚动条的宽度 */
  width: 10px;
  /* 对应横向滚动条的宽度 */
  height: 10px;
}
/* 滚动条上的滚动滑块 */
::-webkit-scrollbar-thumb {
  background-color: #246deb;
  border-radius: 32px;
}
/* 滚动条轨道 */
::-webkit-scrollbar-track {
  background-color: #f5f5f5;
  border-radius: 32px;
}
.boxs {
  width: 100%;
  .center {
    width: 86rem;
    margin: 0 auto;
    height: 100%;
    padding: 2rem;
    box-sizing: border-box;
    .pro_tabs {
      display: flex;
      align-items: center;
      justify-content: center;
      > div {
        width: 11rem;
        height: 4rem;
        border-radius: 0.4rem;
        background: #d9d9d9;
        cursor: pointer;
        color: #fff;
        font-size: 1.4rem;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 2rem;
      }
      .pro_active {
        background: #246deb;
      }
    }
    .centers_boxs {
      margin-top: 2rem;
      .flex_two {
        display: flex;
        justify-content: space-between;
        ::v-deep .el-input {
          width: 28rem;
        }
      }

      .trip_boxs {
        width: 100%;
        height: 26rem;
        border: 1px solid #e5e5ea;
        padding: 2rem 1rem;
        box-sizing: border-box;
        ::v-deep .el-form-item {
          margin-bottom: 2rem;
          .el-input {
            width: 100%;
          }
        }
      }
      .statement {
        display: flex;
        align-items: center;
        .txt_ty {
          span {
            margin: 0 2rem;
          }
          ::v-deep .el-input {
            width: 40rem;
          }
        }
      }
      .feng {
        display: flex;
        .proFm_span {
          color: #ff4d4f;
          font-size: 1.4rem;
          width: 47rem;
          margin-top: auto;
          line-height: 2rem;
          text-align: left;
          margin-left: 2rem;
        }
        .avatar-uploader {
          width: 23rem;
          height: 13rem;
          line-height: 13rem;
        }
        ::v-deep .el-upload {
          border: 1px dashed #e5e5ea;
          border-radius: 6px;
          cursor: pointer;
          position: relative;
          overflow: hidden;
          width: 100%;
          height: 100%;
        }
        .avatar-uploader .el-upload:hover {
          border-color: #409eff;
        }
        .avatar-uploader-icon {
          font-size: 28px;
          color: #8c939d;
          width: 100%;
          height: 100%;
          line-height: 13rem;
          text-align: center;
        }
        .avatar {
          width: 100%;
          height: 100%;
          display: block;
        }
      }
      .saletime {
        display: flex;
        ::v-deep .el-date-editor {
          width: 32rem;
        }
      }
      .WriteTimes {
        width: 100%;
        border: 1px solid #e5e5ea;
        padding: 2rem;
        box-sizing: border-box;
        ::v-deep .el-form-item {
          margin-bottom: 2rem;
          .el-date-editor {
            width: 100%;
          }
        }
      }
      .settings {
        width: 100%;
        border: 1px solid #e5e5ea;
        padding: 2rem;
        box-sizing: border-box;
        ::v-deep .el-form-item {
          margin-bottom: 2rem;
        }
        .flex_two {
          ::v-deep .el-input {
            width: auto !important;
          }
        }
      }
    }
  }
}
.shiyong {
  display: flex;
  span {
    width: 5.2rem;
    display: block;
    &:nth-child(3) {
      margin-left: 2rem;
    }
  }
}
.addtrip,
.add_option {
  width: 11rem;
  height: 4rem;
  border: 1px solid #246deb;
  border-radius: 0.4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #246deb;
  font-size: 1.4rem;
  cursor: pointer;
  margin-left: 4.4rem;
}
.tishi {
  ::v-deep .el-input {
    width: 46rem !important;
  }
}
.disL {
  display: flex;
  flex-direction: column;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 40px;
    /* identical to box height */
    color: #ff4d4f;
  }
}
.daily {
  span {
    line-height: 2rem;
    margin-left: 11.5rem;
  }
  ::v-deep .el-form-item {
    margin-bottom: 1rem;
  }
}
.form_btns {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 4rem;
  > div {
    width: 10rem;
    height: 4rem;
    border-radius: 0.4rem;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-size: 1.4rem;
    cursor: pointer;
    &:nth-child(1) {
      background: #d9d9d9;
    }
  }
  .nexts {
    background: #246deb !important;
    margin-left: 2rem;
  }
}
.close_group {
  width: 2rem;
  height: 2rem;
  margin-left: 2rem;
  margin-top: 1.1rem;
  cursor: pointer;
}

::v-deep .el-dialog__wrapper{
  z-index: 9999 !important;
}
#app{
  width: 100%;
  height: 100%;
}
.tab_title{
  width: 100%;
  display: flex;
  align-items: center;
  margin: 1.8rem 0 0 0;
  >div{
    cursor: pointer;
    width: 11.6rem;
    height: 4rem;
    border-radius: 0.4rem;
    background: #D9D9D9;
    color: #fff;
    font-size: 1.4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 2rem;
  }
  .active_tab{
    background: #246DEB;
  }
}
.main{
  position: relative;
}
.filter_btns{
  display: flex;
  align-items: center;
  >div{
    height: 4rem;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 0.4rem;
    font-size: 1.4rem;
    background: #246DEB;
    color: #fff;
    cursor: pointer;
    width: 10rem;
    margin-right: 2rem;
  }
}
// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 42px auto;
  position: relative;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}
.main_filter{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 2rem;
    >div{
      display: flex;
      align-items: center;
      &:nth-child(1){
        >div{
          margin-right: 2rem;
        }
      }
      &:nth-child(2){
        >div{
          cursor: pointer;
          margin-left: 2rem;
          width: 9.2rem;
          height: 4rem;
          border: 1px solid #246DEB;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 0.4rem;
          img{
            margin-right: 0.8rem;
          }
          span{
            color: #246DEB;
            font-size: 1.4rem;
          }
        }
      }
    }
}
.pages{
  position: relative;
}
.color_btns{
  color: #246DEB;
  font-size: 1.4rem;
  cursor: pointer;
}
.boxs_content{
  border: 1px solid #E5E5EA;
  padding: 2rem 2rem 2rem 0;
  box-sizing: border-box;
  margin-bottom: 2rem;
  flex-direction: column;
}
.flex_tui{
  display: flex;
  align-items: center;
}
.dialogs{
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  z-index: 1990;
  overflow: auto;
  .title_txt{
    position: relative;
    padding: 1.7rem 0;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #000000;
    font-size: 2rem;
    border-bottom: 1px solid #E5E5EA;
    img{
      width: 1.8rem;
      height: 1.8rem;
      position: absolute;
      right: 2rem;
      top: 50%;
      transform: translate(0,-50%);
      cursor: pointer;
    }
  }
}
.pages{
  height: 100%;
}
.main{
  flex: 1;
  width: 100%;
  height: 100%;
  background: #fff;
  padding: 2rem;
  box-sizing: border-box;
  margin-top: 2rem;
  overflow: auto;
}
.flex{
  display: flex;
  align-items: center;
}
.flw_twos{
  justify-content: space-between;
  ::v-deep .el-input{
    width: 16.5rem !important;
  }
}
</style>
